import { MediaBox, MediaFlex, Shimmer } from "@jewlr/storybook/core"
import React from "react"

import Badge from "areas/product/jewlr/wizard-header/badge"
import { IS_JEWLR } from "helpers/application"

import WizardPricingLoading from "./wizard-pricing-loading"

const WizardHeaderLoading = () => (
  <>
    <MediaBox greaterThanOrEqual="tablet">
      {IS_JEWLR() && <Badge />}
      <Shimmer height="28px" mb={1} width="320px" />
      <WizardPricingLoading />
    </MediaBox>
    <MediaFlex
      alignItems="center"
      flexDirection="column"
      lessThan="tablet"
      mb="10px"
    >
      <Shimmer height="16px" mb="10px" width="160px" />
      <Shimmer height="28px" mb={1} mt="6px" width="260px" />
    </MediaFlex>
  </>
)

export default WizardHeaderLoading
